export default __webpack_public_path__ + "static/81621-02c69d7560cd9d87e8275142b7dddcbe.jpg";